import { FunctionComponent } from "react";

import { ListSourceType } from "@/enum/list.enum";

import { CustomEvent } from "@/pages/Private/pages/CustomEvent/schema/customEvent";
import { Map } from "@/pages/Private/pages/Map/schema/map";
import { CsvEnrichment } from "@/pages/Private/pages/CsvEnrichment/schema/csvEnrichment";
import { Job } from "@/pages/Private/pages/Job/schema/job";
import { LiCompanyActivity } from "@/pages/Private/pages/LiCompanyActivity/schema/liCompanyActivity";
import { LiEvent } from "@/pages/Private/pages/LiEvent/schema/liEvent";
import { LiPeople } from "@/pages/Private/pages/LiPeople/schema/liPeople";
import { LiPost } from "@/pages/Private/pages/LiPost/schema/liPost";
import { LiProfileVisits } from "@/pages/Private/pages/LiProfileVisits/schema/liProfileVisits";

import { LiSn } from "@/pages/Private/pages/LiSn/schema/liSn";

import { StepInfo } from "@/components/StepInfo/StepInfo";

import { CreateParallelAiForm } from "@/pages/Private/pages/ParallelAi/components/CreateParallelAiForm";

import { ParallelAi } from "@/pages/Private/pages/ParallelAi/schema/parallelAi";

import { CompanyEnrich } from "@/pages/Private/pages/CompanyEnrich/schema/companyEnrich";

import { AddedSourceList } from "../../../components/AddedSourceList";
import { List } from "../../../schema/list";
import { FundingMa } from "../../../../FundingMa/schema/funding-ma";
import { Swarm } from "../../../../Swarm/schema/swarm";

export interface ParallelAiSourceProps {
	data: List;
	duplicated:
		| Map
		| Job
		| CsvEnrichment
		| LiEvent
		| LiCompanyActivity
		| LiPost
		| LiProfileVisits
		| LiPeople
		| LiSn
		| ParallelAi
		| FundingMa
		| Swarm
		| CompanyEnrich
		| null;
	selected:
		| Map
		| Job
		| CsvEnrichment
		| LiEvent
		| LiCompanyActivity
		| LiPost
		| LiProfileVisits
		| LiPeople
		| CustomEvent
		| LiSn
		| ParallelAi
		| FundingMa
		| Swarm
		| CompanyEnrich
		| null;
	setDuplicated: (
		map:
			| Map
			| Job
			| CsvEnrichment
			| LiEvent
			| LiCompanyActivity
			| LiPost
			| LiProfileVisits
			| LiPeople
			| LiSn
			| ParallelAi
			| FundingMa
			| Swarm
			| CompanyEnrich
			| null
	) => void;
	setSelected: (
		map:
			| Map
			| Job
			| CsvEnrichment
			| LiEvent
			| LiCompanyActivity
			| LiPost
			| LiProfileVisits
			| LiPeople
			| LiSn
			| ParallelAi
			| CustomEvent
			| FundingMa
			| Swarm
			| CompanyEnrich
			| null
	) => void;
}

export const ParallelAiSource: FunctionComponent<ParallelAiSourceProps> = ({
	data,
	duplicated,
	selected,
	setDuplicated,
	setSelected,
}) => {
	if (data.sourceType === ListSourceType.PARALLEL_AI) {
		return (
			<>
				<StepInfo
					description={
						<>
							<p>
								Enter a prompt to describe the type of companies you are looking for. We will find
								matching companies and enrich them with contact data. You can add multiple sources
								to combine different search criteria.
							</p>
						</>
					}
					title="Build a list with AI Prompt"
					videoId=""
				/>
				<div className="flex flex-row gap-8">
					<div className="grow relative w-1/2">
						{duplicated ? (
							<CreateParallelAiForm
								handleDuplicate={setDuplicated}
								handleSelect={setSelected}
								list={data as List}
								parallelAi={duplicated as ParallelAi}
							/>
						) : selected ? (
							<CreateParallelAiForm
								handleSelect={setSelected}
								list={data as List}
								parallelAi={selected as ParallelAi}
							/>
						) : (
							<CreateParallelAiForm list={data as List} />
						)}
					</div>
					<div className="w-1/2">
						<AddedSourceList
							handleDuplicate={(item) => {
								setDuplicated(item);
								setSelected(null);
							}}
							handleSelect={(item) => {
								setSelected(item);
								setDuplicated(null);
							}}
							list={data as List}
						/>
					</div>
				</div>
			</>
		);
	}

	return <></>;
};
